import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isRentDropdownOpen, setIsRentDropdownOpen] = useState(false);
  const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="bg-white shadow-sm border-b border-gray-100 relative z-50">
        {/* Top Navigation Bar */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            
            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-gray-700 hover:text-purple-600 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>

            {/* Logo - Centered on mobile, left on desktop */}
            <div className="flex items-center lg:flex-1 lg:justify-start">
              <Link to="/" className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-800 bg-clip-text text-transparent hover:from-gray-800 hover:to-gray-700 transition-all duration-300">
                fillmyfloor
              </Link>
            </div>

            {/* Desktop Navigation - Hidden on mobile */}
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200">
                Home
              </Link>
              
              <div className="relative group">
                <button 
                  className="flex items-center text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200"
                  onMouseEnter={() => setIsRentDropdownOpen(true)}
                  onMouseLeave={() => setIsRentDropdownOpen(false)}
                >
                  Rent
                  <svg className="w-4 h-4 ml-1.5 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isRentDropdownOpen && (
                  <div className="absolute top-full left-0 mt-3 w-56 bg-white rounded-xl shadow-xl border border-gray-100 z-50 transform opacity-100 scale-100 transition-all duration-200">
                    <div className="py-2">
                      <Link to="/rent" className="block px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        Furniture Rental
                      </Link>
                      <Link to="/rent" className="block px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        Appliance Rental
                      </Link>
                      <Link to="/rent" className="block px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        Office Furniture
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              
              <div className="relative">
                <Link to="/buy" className="flex items-center text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200">
                  <span className="bg-gradient-to-r from-green-400 to-emerald-500 text-white text-xs px-2.5 py-1 rounded-full mr-2 font-medium">New</span>
                  Buy Furniture
                </Link>
              </div>
              
              <Link to="/wfh" className="text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200">
                WFH Combo
              </Link>
            </div>

            {/* Right Side - Desktop */}
            <div className="hidden lg:flex items-center space-x-6">
              <div className="relative group">
                <button 
                  className="flex items-center text-gray-700 hover:text-purple-600 transition-colors duration-200"
                  onMouseEnter={() => setIsLocationDropdownOpen(true)}
                  onMouseLeave={() => setIsLocationDropdownOpen(false)}
                >
                  <svg className="w-4 h-4 mr-2 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="font-medium">Pune</span>
                  <svg className="w-4 h-4 ml-1.5 transition-transform duration-200 group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isLocationDropdownOpen && (
                  <div className="absolute top-full right-0 mt-3 w-48 bg-white rounded-xl shadow-xl border border-gray-100 z-50 transform opacity-100 scale-100 transition-all duration-200">
                    <div className="py-2">
                      <button className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        Mumbai
                      </button>
                      <button className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        Delhi
                      </button>
                      <button className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        Bangalore
                      </button>
                    </div>
                  </div>
                )}
              </div>
              
              <button className="text-gray-700 hover:text-purple-600 transition-colors duration-200 p-2 hover:bg-gray-50 rounded-lg">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
              
              <button className="bg-gradient-to-r from-gray-900 to-gray-800 text-white px-6 py-2.5 rounded-lg hover:from-gray-800 hover:to-gray-700 font-medium transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                Login
              </button>
              
              <div className="relative">
                <button className="text-gray-700 hover:text-purple-600 transition-colors duration-200 p-2 hover:bg-gray-50 rounded-lg">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                  </svg>
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                    0
                  </span>
                </button>
              </div>
            </div>

            {/* Mobile Right Side - Cart and Login */}
            <div className="flex lg:hidden items-center space-x-3">
              <button className="text-gray-700 hover:text-purple-600 transition-colors duration-200 p-2 hover:bg-gray-50 rounded-lg">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
              
              <div className="relative">
                <button className="text-gray-700 hover:text-purple-600 transition-colors duration-200 p-2 hover:bg-gray-50 rounded-lg">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                  </svg>
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-medium text-xs">
                    0
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4 lg:pb-6">
          <div className="flex items-center justify-center">
            <div className="flex items-center bg-white rounded-xl lg:rounded-2xl shadow-lg border border-gray-100 w-full max-w-2xl overflow-hidden">
              <div className="flex items-center px-4 lg:px-6 py-3 lg:py-4 border-r border-gray-100 bg-gray-50">
                <svg className="w-4 h-4 text-purple-500 mr-2 lg:mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-gray-600 font-medium text-sm lg:text-base">Pune</span>
                <svg className="w-4 h-4 ml-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <input 
                type="text" 
                placeholder="Search for furniture, appliances..." 
                className="flex-1 px-4 lg:px-6 py-3 lg:py-4 outline-none text-gray-700 placeholder-gray-400 text-sm lg:text-base"
              />
              <button className="bg-gradient-to-r from-gray-900 to-gray-800 text-white px-6 lg:px-8 py-3 lg:py-4 hover:from-gray-800 hover:to-gray-700 transition-all duration-200 transform hover:scale-105">
                <svg className="w-4 lg:w-5 h-4 lg:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Drawer - Overlay */}
      {isMobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          
          {/* Drawer */}
          <div className="fixed top-0 left-0 h-full w-80 max-w-[85vw] bg-white shadow-2xl z-50 lg:hidden transform transition-transform duration-300 ease-in-out">
            <div className="flex flex-col h-full">
              {/* Drawer Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100">
                <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-800 bg-clip-text text-transparent">
                  fillmyfloor
                </Link>
                <button 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-500 hover:text-gray-700 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Drawer Content */}
              <div className="flex-1 overflow-y-auto">
                <div className="p-6 space-y-6">
                  {/* Mobile Navigation Links */}
                  <div className="space-y-4">
                    <Link to="/" className="block text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200 py-3 border-b border-gray-100">
                      Home
                    </Link>
                    <Link to="/rent" className="block text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200 py-3 border-b border-gray-100">
                      Rent
                    </Link>
                    <Link to="/buy" className="flex items-center text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200 py-3 border-b border-gray-100">
                      <span className="bg-gradient-to-r from-green-400 to-emerald-500 text-white text-xs px-2.5 py-1 rounded-full mr-3 font-medium">New</span>
                      Buy Furniture
                    </Link>
                    <Link to="/wfh" className="block text-gray-800 hover:text-purple-600 font-medium transition-colors duration-200 py-3 border-b border-gray-100">
                      WFH Combo
                    </Link>
                  </div>

                  {/* Mobile Location and Login */}
                  <div className="pt-6 space-y-4">
                    <div className="flex items-center text-gray-700 p-3 bg-gray-50 rounded-lg">
                      <svg className="w-5 h-5 mr-3 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <span className="font-medium">Pune</span>
                    </div>
                    <button className="w-full bg-gradient-to-r from-gray-900 to-gray-800 text-white px-6 py-4 rounded-lg hover:from-gray-800 hover:to-gray-700 font-medium transition-all duration-200 shadow-md">
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header; 